import { Component } from "../Component";
import { KeySequenceNavigationHandler } from "./KeySequenceNavigationHandler";
import { KeySpatialNavigationHandler } from "./KeySpatialNavigationHandler";
// import { KeyZoomHandler } from "./KeyZoomHandler";
import { KeyPlayHandler } from "./KeyPlayHandler";
/**
 * @class KeyboardComponent
 *
 * @classdesc Component for keyboard event handling.
 *
 * To retrive and use the keyboard component
 *
 * @example
 * ```
 * var viewer = new Mapillary.Viewer({ ... });
 *
 * var keyboardComponent = viewer.getComponent("keyboard");
 * ```
 */
export class KeyboardComponent extends Component {
    /** @ignore */
    constructor(name, container, navigator) {
        super(name, container, navigator);
        this._keyPlayHandler = new KeyPlayHandler(this, container, navigator);
        this._keySequenceNavigationHandler = new KeySequenceNavigationHandler(this, container, navigator);
        this._keySpatialNavigationHandler = new KeySpatialNavigationHandler(this, container, navigator);
    }
    /**
     * Get key play.
     *
     * @returns {KeyPlayHandler} The key play handler.
     */
    get keyPlay() {
        return this._keyPlayHandler;
    }
    /**
     * Get key sequence navigation.
     *
     * @returns {KeySequenceNavigationHandler} The key sequence navigation handler.
     */
    get keySequenceNavigation() {
        return this._keySequenceNavigationHandler;
    }
    /**
     * Get spatial.
     *
     * @returns {KeySpatialNavigationHandler} The spatial handler.
     */
    get keySpatialNavigation() {
        return this._keySpatialNavigationHandler;
    }
    _activate() {
        this._configurationSubscription = this._configuration$.subscribe((configuration) => {
            if (configuration.keyPlay) {
                this._keyPlayHandler.enable();
            }
            else {
                this._keyPlayHandler.disable();
            }
            if (configuration.keySequenceNavigation) {
                this._keySequenceNavigationHandler.enable();
            }
            else {
                this._keySequenceNavigationHandler.disable();
            }
            if (configuration.keySpatialNavigation) {
                this._keySpatialNavigationHandler.enable();
            }
            else {
                this._keySpatialNavigationHandler.disable();
            }
        });
    }
    _deactivate() {
        this._configurationSubscription.unsubscribe();
        this._keyPlayHandler.disable();
        this._keySequenceNavigationHandler.disable();
        this._keySpatialNavigationHandler.disable();
    }
    _getDefaultConfiguration() {
        return { keyPlay: true, keySequenceNavigation: true, keySpatialNavigation: true };
    }
}
KeyboardComponent.componentName = "keyboard";
//# sourceMappingURL=KeyboardComponent.js.map